import { internalLogger } from '../../interface/v1/clientOsLogger';
import IGraphQLService from '../../services/graphQLService/IGraphQLService';
import { RESIDENCE_COUNTRY_QUERY } from './queries/residenceCountryQuery';
import {
  AggregationClientDependencies,
  GetResidenceCountryGraphQLResponse
} from './types';

export default class AggregationClient {
  private readonly graphQLService: IGraphQLService;

  constructor({ graphQLService }: AggregationClientDependencies) {
    this.graphQLService = graphQLService;
  }

  async getResidenceCountry(): Promise<string> {
    const client = this.graphQLService?.getClient?.();
    if (!client?.query) {
      /* istanbul ignore next */
      internalLogger?.system(
        'GraphQL client is not available or does not have a query method.'
      );
      return '';
    }
    const result = await client.query<
      GetResidenceCountryGraphQLResponse,
      Record<string, unknown>
    >(RESIDENCE_COUNTRY_QUERY, undefined, { fetchPolicy: 'no-cache' });

    return result.data?.account?.user?.residenceCountry || '';
  }
}
